import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_AD_TENANT_ID}`,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Warning
        }
    }
};

const loginRequest = {
    scopes: ['openid', 'profile', 'email']
};

const msalInstance = new PublicClientApplication(msalConfig);

export { msalInstance, loginRequest };
